import { type LabColorInput, toLabColor } from './toLabColor'

export const buildStainingColorModelPayload = ({
  aestheticmodelstainingbrand,
  protocol,
  backgroundcolor,
  targetcolor,
}: {
  aestheticmodelstainingbrand?: string | null
  protocol?: string
  backgroundcolor?: LabColorInput | null
  targetcolor?: LabColorInput | null
}): Record<string, unknown> => {
  const background = toLabColor(backgroundcolor)
  const target = toLabColor(targetcolor)

  return {
    aestheticmodelstainingbrand: aestheticmodelstainingbrand || '',
    protocol,
    ...(background ? { backgroundcolor: background } : {}),
    ...(target ? { targetcolor: target } : {}),
  }
}
